$(function () {
	var $body = $('body');
	$('.menu-trigger').on('click', function () {
		$body.toggleClass('opened');
	});
	$('.overlay, .menu-close, .target a').on('click', function () {
		$body.removeClass('opened');
	});
});


$(function() {
	$('a[href*="#"]:not([href^="#inline"])').click(function() {
		if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
			var target = $(this.hash);
			target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
			var targettop = target.offset().top;
			var header = document.querySelector('.header-wrap');
			var headerHeight = header ? header.offsetHeight : 0;
			var scrollPosition = targettop - headerHeight;
			if (target.length) {
			$('html, body').animate({
				scrollTop: scrollPosition
			}, 1000);
			return false;
			}
		}
	});
});


$(function(){
	$(".inview").one("inview", function (event, isInView) {
		if (isInView) {
			$(this).stop().addClass("visible");
		}
	});
});
$(function(){
	$(".inviewelm > *").one("inview", function (event, isInView) {
		if (isInView) {
			$(this).stop().addClass("visible");
		}
	});
});
$(function(){
	$(".itemK").one("inview", function (event, isInView) {
		if (isInView) {
			$(this).stop().addClass("show");
		}
	});
});


$(window).on('load resize', function(){
	$(window).scroll(function(){
		var scrollTop = $(this).scrollTop();
		if( scrollTop > 100 ){
			$('body').addClass('moved');
		}
		else{
			$('body').removeClass('moved');
		}
	}).scroll();
});


const relatedslide = new Swiper(".related-slide",{
	slidesPerView: 'auto',
	spaceBetween: 0,
	slidesPerGroup: 1,
	loop: false,
	grabCursor: true,
	mousewheel: {
		forceToAxis: true,
		sensitivity: 1,
	},
});

document.addEventListener('DOMContentLoaded', function() {
	new Swiper('.background-slider', {
		loop: true,
		effect: 'fade',
		fadeEffect: {
			crossFade: true,
		},
		autoplay: {
			delay: 4000,
			disableOnInteraction: false,
		},
		speed: 2000,
	});
});